import { commonRequest } from '@/common/utils/request'
import mainApi from '@/common/api/urls'
import { getLoginBrandInfo } from '@RootCommon/utils'

/**
 * 获取实体的logo和主图信息，并与当前LOGIN_BRANDINFO整合
 * @param accountId 账号ID
 * @param acctType 账号类型
 * @param entityId 实体ID
 * @returns 整合后的品牌信息
 */
export const fetchEntityLogoAndMainPic = async (accountId: string, acctType: string, entityId: string) => {
  try {
    // 调用接口获取logo和主图
    const response = await commonRequest.post(mainApi.queryEntityLogoAndMainPic, {
      accountId,
      acctType,
      entityId,
    })
    return response
  } catch (error) {
    console.error('获取品牌logo和主图失败:', error)
    return getLoginBrandInfo() || {}
  }
}
